export function countsTowardCompleteness(section) {
    return section?.countsTowardCompleteness !== false;
}

export function isGroupComplete(sectionsState, sectionDefs) {
    return sectionDefs
        .filter(countsTowardCompleteness)
        .every((section) => Boolean(sectionsState[section.id]?.isComplete));
}

export function countedCompleteCount(sectionsState, sectionDefs) {
    return sectionDefs.filter(
        (section) => countsTowardCompleteness(section) && sectionsState[section.id]?.isComplete
    ).length;
}
